import { render, staticRenderFns } from "./requiresPersonalisation.vue?vue&type=template&id=39dbc98d&"
import script from "./requiresPersonalisation.vue?vue&type=script&lang=js&"
export * from "./requiresPersonalisation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39dbc98d')) {
      api.createRecord('39dbc98d', component.options)
    } else {
      api.reload('39dbc98d', component.options)
    }
    module.hot.accept("./requiresPersonalisation.vue?vue&type=template&id=39dbc98d&", function () {
      api.rerender('39dbc98d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/pages/productAside/Actions/requiresPersonalisation.vue"
export default component.exports